import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = { data: {}, missedCallee: '' };

const callingContactSlice = createSlice({
  name: 'callingContact',
  initialState,
  reducers: {
    addCallingContact(state, action: PayloadAction<any>) {
      state.data = action.payload;
    },
    clearCallingContact(state) {
      state.data = {};
    },
    setMissedCallCallee(state, action: PayloadAction<any>) {
      state.missedCallee = action.payload;
    },
    clearMissedCallCallee(state) {
      state.missedCallee = '';
    },
  },
});

export const { addCallingContact, clearCallingContact, setMissedCallCallee, clearMissedCallCallee } = callingContactSlice.actions;

export default callingContactSlice.reducer;
